import { Box } from '@chakra-ui/react';
import {
   type CountryCode,
   type LanguageCode,
   ShopifyStorefrontProvider,
} from '@ifixit/shopify-storefront-client';
import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { useState } from 'react';
import { SidebarDataType } from './Sidebar/sidebar';
import { Navigation } from './navigation';
import { UserTabs } from './user_tabs';
import { UserView } from './user_view';

function getInitialUnreadNotifCount(viewData: any): number {
   for (const viewDatum of viewData) {
      if (viewDatum.name === 'Notifications') {
         return viewDatum.data.notif_count;
      }
   }
   return 0;
}

const UserPage = ({
   userid,
   viewData,
   editUrl,
   usersUrl,
   sidebarData,
   activeTab,
   shopifyStore,
}: {
   userid: number;
   viewData: any[];
   editUrl?: string;
   usersUrl: string;
   sidebarData: SidebarDataType;
   activeTab: string;
   shopifyStore: {
      currencyCode: string;
      country: CountryCode;
      language: LanguageCode;
      storeCode: string;
      shopDomain: string;
      storefrontAccessToken: string;
   };
}) => {
   const [currentTab, setCurrentTab] = useState(activeTab);
   const [unreadNotifCount, setUnreadNotifCount] = useState(getInitialUnreadNotifCount(viewData));

   return (
      <ShopifyStorefrontProvider {...shopifyStore}>
         <Box marginY="24px">
            <Navigation editUrl={editUrl} usersUrl={usersUrl} />
            <UserTabs
               viewTabs={viewData}
               notifBadge={unreadNotifCount}
               currentTab={currentTab}
               setCurrentTab={setCurrentTab}
            />
            <UserProfileDisplay
               userid={userid}
               viewData={viewData}
               currentTab={currentTab}
               setUnreadNotifCount={setUnreadNotifCount}
               sidebarData={sidebarData}
            />
         </Box>
      </ShopifyStorefrontProvider>
   );
};

const UserProfileDisplay = ({
   userid,
   viewData,
   currentTab,
   setUnreadNotifCount,
   sidebarData,
}: {
   userid: number;
   viewData: any[];
   currentTab: string;
   setUnreadNotifCount: (count: number) => void;
   sidebarData: SidebarDataType;
}) => {
   const selectedTab = viewData.find((tab: any) => tab.name === currentTab);
   return (
      <UserView
         userid={userid}
         currentTab={selectedTab}
         setUnreadNotifCount={setUnreadNotifCount}
         sidebarData={sidebarData}
      />
   );
};

initializeChakraComponent('UserPage', UserPage);
